<script setup lang="ts">
  import type { Benefit } from '@/models/benefit';
  import type { PropType } from 'vue';

  defineProps({
    benefit: {
      type: Object as PropType<Benefit>,
      required: true
    }
  });
</script>

<template>
  <div class="benefit-card">
    <div class="benefit-card__left">
      <div
        v-if="benefit.icon"
        class="benefit-card__icon">
        <nuxt-icon
          v-if="benefit.icon"
          :name="`telekom:${benefit.icon}`" />
      </div>
    </div>
    <div class="benefit-card__right">
      <p class="benefit-card__title">{{ benefit.title }}</p>
      <p class="benefit-card__description">{{ benefit.description }}</p>
    </div>
  </div>
</template>
